// extracted by mini-css-extract-plugin
module.exports = {"couponAlert":"couponAlert_couponAlert__ZugQ0","title":"couponAlert_title__5yOrP","description":"couponAlert_description__cWceQ"};